
import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Trip } from '@/types/itinerary';
import { Tabs, TabsContent } from '@/components/ui/tabs';
import { useTransportation } from '@/hooks/travel/useTransportation';
import { useTransportationEvents } from '@/hooks/travel/useTransportationEvents';
import TravelTabs from '@/components/travel/TravelTabs';
import TransportationTab from '@/components/travel/tabs/TransportationTab';
import HotelsTab from '@/components/travel/tabs/HotelsTab';
import TravelersTab from '@/components/travel/TravelersTab';
import TravelSchedule from '@/components/travel/TravelSchedule';

interface TripContextType {
  trip: Trip;
  isAuthorized: boolean;
}

const Travel: React.FC = () => {
  const {
    trip,
    isAuthorized
  } = useOutletContext<TripContextType>();
  const [activeTab, setActiveTab] = useState('travelers');
  
  const {
    transportationEvents,
    isLoading,
    error,
    fetchTransportationEvents,
    clearError
  } = useTransportationEvents(trip);
  
  const {
    outboundDetails,
    returnDetails,
    handleOutboundChange,
    handleReturnChange,
    saveOutboundDetails,
    saveReturnDetails,
    isAddDialogOpen,
    openAddTransportationDialog,
    closeAddTransportationDialog
  } = useTransportation(trip, isAuthorized);

  return <div className="space-y-6">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TravelTabs activeTab={activeTab} onTabChange={setActiveTab} />

        <TabsContent value="travelers" className="pt-2">
          <TravelersTab tripId={trip?.id} isAuthorized={isAuthorized} />
        </TabsContent>
        
        <TabsContent value="transport" className="pt-2">
          <div className="space-y-6">
            <TravelSchedule 
              transportationEvents={transportationEvents} 
              isLoading={isLoading} 
              error={error} 
              isAuthorized={isAuthorized} 
              onRefresh={fetchTransportationEvents} 
              onRetry={fetchTransportationEvents} 
              onAddTransportation={openAddTransportationDialog} 
              forSelectedDate={false}
            />
            
            <TransportationTab 
              outboundDetails={outboundDetails} 
              returnDetails={returnDetails} 
              handleOutboundChange={handleOutboundChange} 
              handleReturnChange={handleReturnChange} 
              saveOutboundDetails={saveOutboundDetails} 
              saveReturnDetails={saveReturnDetails} 
              isAuthorized={isAuthorized} 
            />
          </div>
        </TabsContent>
        
        <TabsContent value="hotels" className="pt-2">
          <HotelsTab tripId={trip.id} isAuthorized={isAuthorized} />
        </TabsContent>
      </Tabs>
    </div>;
};

export default Travel;
